import { useAuth } from "./useAuth";

export function useCurrentUser() {
  const auth = useAuth();
  return auth.getUser();
}
